module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [
    [_c('div', {
      staticClass: "container"
    }, [(_vm.error) ? [_c('div', {
      staticClass: "alert alert-danger",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v(_vm._s(_vm.error))])] : _vm._e(), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-6"
    }, [_c('full-info-box', {
      attrs: {
        "campaign": _vm.campaign,
        "configuration": "checkout.infobox"
      }
    })], 1), _c('div', {
      staticClass: "col-md-12 col-lg-6 text-center"
    }, [_c('div', {
      staticClass: "alert alert-custom mt-lg-5"
    }, [_c('p', {
      staticClass: "hidden-sm-down"
    }, [_vm._v(_vm._s(_vm.$t('pos.checkout.remember.title')))]), _vm._v(_vm._s(_vm.$t('pos.checkout.remember.description')))]), _c('div', [(!_vm.cannotSave) ? _c('b-button', {
      class: ["desktop-confirm", "btn-confirm", "d-inline-block"],
      attrs: {
        "size": "lg",
        "variant": "success",
        "disabled": (!_vm.isOnline && !_vm.saving) || _vm.cannotSave
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.save($event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pos.checkout.save')))]) : _c('div', {
      staticClass: "mt-2 alert alert-danger"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('pos.checkout.appointedOnboarding-warning')))])])], 1)])])], 2), _c('b-button', {
      class: ["btn-confirm", "btn-block", "mobile-confirm", "main-confirm"],
      attrs: {
        "size": "lg",
        "variant": "success",
        "disabled": (!_vm.isOnline && !_vm.saving) || _vm.cannotSave
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.save($event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pos.checkout.save')))])]
  ]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46b54b10"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-checkout/CampaignCheckout.vue
// module id = 930
// module chunks = 1